/**
 * Lectura de un fichero CSV con detección de codificación (decisión 7 de Robert):
 * Excel en español guarda CSV con separador `;` y codificación Windows-1252. UTF-8 se
 * intenta primero en modo estricto; si falla, se decodifica como Windows-1252. El BOM
 * de UTF-8 se elimina. El separador (`;` o `,`) lo detecta papaparse (`delimiter: ""`).
 */
export const decodificarCSV = (bytes: ArrayBuffer | Uint8Array): string => {
  const datos = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let texto: string;
  try {
    texto = new TextDecoder("utf-8", { fatal: true }).decode(datos);
  } catch {
    texto = new TextDecoder("windows-1252").decode(datos);
  }
  return texto.charCodeAt(0) === 0xfeff ? texto.slice(1) : texto;
};

/** Separador más probable de la primera línea (`;` si aparece más veces que `,`). */
export const detectarSeparador = (texto: string): ";" | "," => {
  const primera = texto.split(/\r?\n/, 1)[0] ?? "";
  const puntoComa = (primera.match(/;/g) ?? []).length;
  const coma = (primera.match(/,/g) ?? []).length;
  return puntoComa >= coma && puntoComa > 0 ? ";" : ",";
};

export const leerTextoCSV = async (fichero: Blob): Promise<string> =>
  decodificarCSV(await fichero.arrayBuffer());
